import React from "react"

import { connect } from "react-redux"
import PropTypes from "prop-types"

import { Form, FormGroup, FormFeedback, InputGroup, UncontrolledModal, ModalHeader, ModalBody, ModalFooter } from "../../../../components"

import * as ACTIONS from "../../../../store/actions"
import CommentsEditor from "./CommentsEditor"

class Reply_EditForm extends React.Component {
	static propTypes = {
		target: PropTypes.string.isRequired,
		periodEnd: PropTypes.object.isRequired,
		query: PropTypes.object.isRequired,
		reply: PropTypes.object.isRequired,
		updateReply: PropTypes.func.isRequired,
	}

	constructor(props) {
		super(props)

		this.state = { comments: props.reply.comments }

		this.handleCommentsChange = this.handleCommentsChange.bind(this)
		this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
		this.handleActionButtonClick = this.handleActionButtonClick.bind(this)
	}

	handleCommentsChange(value) {
		this.setState({
			comments: value,
		})
	}

	handleCancelButtonClick(e) {
		this.setState({ comments: this.props.reply.comments })
		return true
	}

	handleActionButtonClick(e) {
		if (!this.isValid) {
			this.setState({ showValidation: true })
			return
		}

		this.props.updateReply({
			periodEnd: this.props.periodEnd,
			queryId: this.props.query.id,
			replyId: this.props.reply.id,
			comments: this.state.comments,
		})
		return true
	}

	get isCommentsRequired() {
		return !(this.state.comments && this.state.comments.length)
	}

	get isValid() {
		return !this.isCommentsRequired
	}

	render() {
		return (
			<UncontrolledModal target={this.props.target}>
				<Form onSubmit={this.handleSubmit}>
					<ModalHeader tag="h6">Edit Reply</ModalHeader>

					<ModalBody>
						<FormGroup row>
							<InputGroup>
								<CommentsEditor
									invalid={this.state.showValidation && this.isCommentsRequired}
									value={this.state.comments}
									onChange={this.handleCommentsChange}
								/>
								<FormFeedback>Comments are required</FormFeedback>
							</InputGroup>
						</FormGroup>
					</ModalBody>

					<ModalFooter>
						<UncontrolledModal.Cancel color="link" className="text-primary" onClick={this.handleCancelButtonClick}>
							Cancel
						</UncontrolledModal.Cancel>
						<UncontrolledModal.Close color="default" className="text-primary" disabled={!this.isValid} onClick={this.handleActionButtonClick}>
							Save
						</UncontrolledModal.Close>
					</ModalFooter>
				</Form>
			</UncontrolledModal>
		)
	}
}

const mapDispatchToProps = dispatch => ({
	updateReply: payload =>
		dispatch({
			type: ACTIONS.PERIODEND_UPDATE_REPLY,
			...payload,
		}),
})

export default connect(null, mapDispatchToProps)(Reply_EditForm)
